export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M10.62 9.96a5.9 5.9 0 001.08-3.42A5.76 5.76 0 006.01.71 5.76 5.76 0 00.32 6.54a5.76 5.76 0 005.7 5.83c1.3 0 2.5-.45 3.46-1.2l3.87 3.87a.83.83 0 101.18-1.18l-3.9-3.9zm-.17-3.42a4.51 4.51 0 01-4.44 4.58 4.51 4.51 0 01-4.44-4.58 4.51 4.51 0 014.44-4.58 4.51 4.51 0 014.44 4.58z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "15",
    "height": "16",
    "fill": "#707070",
    "viewBox": "0 0 15 16"
  }
};